import { Pipe, PipeTransform } from '@angular/core';
import { Document } from '../models/document';
import { Territory } from '../models/territory';

/**
 * Shows the territories of the trademarks of a document, like the document page
 * does (EM is shown as EU), even when the document does not mention them.
 * A document without trademark keeps all its territories.
 */
@Pipe({
  name: 'trademarkTerritories'
})
export class TrademarkTerritoriesPipe implements PipeTransform {

  transform(document: Pick<Document, 'territories' | 'trademarks'>, territories: Territory[] = []): string[] {
    if (!document?.trademarks || document.trademarks.length === 0) {
      return document?.territories ?? [];
    }

    const designations = [...new Set(document.trademarks.map((trademark) => trademark.countryOfDesignation))];
    if (territories.length === 0) {
      return designations;
    }

    return territories
      .filter((territory) => designations.includes(territory.code)
        || territory.alternateCodes?.some((code) => designations.includes(code)))
      .map((territory) => territory.code);
  }

}
